import { IconCreditCard } from '@calendly/ui/components/glyphs/IconCreditCard'
import { IconCalendar } from '@calendly/ui/components/glyphs/IconCalendar'
import { IconCheck } from '@calendly/ui/components/glyphs/IconCheck'
import { IconFile } from '@calendly/ui/components/glyphs/IconFile'
import { IconMail } from '@calendly/ui/components/glyphs/IconMail'
import { IconUserSquareRounded } from '@calendly/ui/components/glyphs/IconUserSquareRounded'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { useI18n } from 'locales'

import {
  PhonePaymentSuccessContainer,
  PhonePaymentSuccessIcon,
  PhonePaymentSuccessTitle,
  PhonePaymentSuccessTitleGroup,
  PhonePaymentSuccessDescription,
  PhonePaymentSuccessDetails,
  PhonePaymentSuccessDetailRow,
  PhonePaymentSuccessDetailText,
  PhonePaymentSuccessConfirmation,
  PhonePaymentSuccessDownloadButton,
} from './styles'

const InvoiceMobilePaidSuccess = ({
  invoice,
  amountDueValue,
  paidAtFormatted,
  onDownloadInvoice,
}) => {
  const { i18n } = useI18n()

  return (
    <PhonePaymentSuccessContainer>
      <PhonePaymentSuccessIcon>
        <UiIcon icon={IconCheck} size="medium" aria-hidden />
      </PhonePaymentSuccessIcon>
      <PhonePaymentSuccessTitleGroup>
        <PhonePaymentSuccessTitle>
          {i18n.t('booking.invoice.payment_received')}
        </PhonePaymentSuccessTitle>
        <PhonePaymentSuccessDescription>
          {i18n.t('booking.invoice.payment_received_description', {
            invoice_number: invoice.invoice_number,
          })}
        </PhonePaymentSuccessDescription>
      </PhonePaymentSuccessTitleGroup>
      <PhonePaymentSuccessDetails>
        <PhonePaymentSuccessDetailRow>
          <UiIcon icon={IconCreditCard} size="small" aria-hidden />
          <PhonePaymentSuccessDetailText>
            {i18n.t('booking.invoice.amount_paid_line', { amount: amountDueValue })}
          </PhonePaymentSuccessDetailText>
        </PhonePaymentSuccessDetailRow>
        <PhonePaymentSuccessDetailRow>
          <UiIcon icon={IconFile} size="small" aria-hidden />
          <PhonePaymentSuccessDetailText>
            {i18n.t('booking.invoice.invoice_number', {
              invoice_number: invoice.invoice_number,
            })}
          </PhonePaymentSuccessDetailText>
        </PhonePaymentSuccessDetailRow>
        <PhonePaymentSuccessDetailRow>
          <UiIcon icon={IconCalendar} size="small" aria-hidden />
          <PhonePaymentSuccessDetailText>
            {i18n.t('booking.invoice.paid_on', { date: paidAtFormatted })}
          </PhonePaymentSuccessDetailText>
        </PhonePaymentSuccessDetailRow>
        {invoice?.contact?.full_name ? (
          <PhonePaymentSuccessDetailRow>
            <UiIcon icon={IconUserSquareRounded} size="small" aria-hidden />
            <PhonePaymentSuccessDetailText>
              {invoice.contact.full_name}
            </PhonePaymentSuccessDetailText>
          </PhonePaymentSuccessDetailRow>
        ) : null}
        {invoice?.contact?.primary_email ? (
          <PhonePaymentSuccessDetailRow>
            <UiIcon icon={IconMail} size="small" aria-hidden />
            <PhonePaymentSuccessDetailText>
              {invoice.contact.primary_email}
            </PhonePaymentSuccessDetailText>
          </PhonePaymentSuccessDetailRow>
        ) : null}
      </PhonePaymentSuccessDetails>
      <PhonePaymentSuccessConfirmation>
        {i18n.t('booking.invoice.payment_received_confirmation')}
      </PhonePaymentSuccessConfirmation>
      <PhonePaymentSuccessDownloadButton wide onClick={onDownloadInvoice}>
        {i18n.t('booking.invoice.download_invoice')}
      </PhonePaymentSuccessDownloadButton>
    </PhonePaymentSuccessContainer>
  )
}

export default InvoiceMobilePaidSuccess
